<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="drug_list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :infiniteLoad="true"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            @editcompounddrug="editcompounddrug"
            @removeItem="removeItem"
        >
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="addcompounddrug">新增</el-button>
            </template>
        </crud-facecade>
        <!-- <div v-wechat-title="title" class="padding5" style="height: 100%">
        <el-row type="flex" align="middle">
            <el-col :md="4" :xl="3" class="align-left">
                <item-input type="string" v-model="compounddrug_search_key" placeholder="药品名称"></item-input>
            </el-col>
            <el-col :md="3" :xl="2" class="align-left">
                <item-input type="string" v-model="compounddrug_search_key" placeholder="药品名称"></item-input>
            </el-col>
        </el-row>
        <list-view ref="plist" :datalist="listdata" :tableHeight="this.screenHeight - 186" :columns="columnList" :buttons="[]">
        </list-view>
    </div> -->
        <CompoundDrugEdit :visible.sync="saveas.dialogFormVisible" :currentItem="saveas" @save-success="saveAsSuccess"></CompoundDrugEdit>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CompoundDrugEdit from './CompoundDrugEdit.vue'
export default {
    name: `compound_drug`,
    components: { CompoundDrugEdit },
    props: {

    },
    data() {
        return {
            title: `基础数据-复合用药`,
            listdata: [],
            url: {
                baseURL: `/api/AcisSystem/CompoundDrug`,
                get: paras => {
                    console.log(`aaa`)
                    let r = this.ReloadListData()
                    return r
                },
                putMany: row => {
                    return new Promise(resolve => {
                        console.log(`bbb`)
                        let r = this.ReloadListData()
                        return r
                    })
                }
            },
            saveas: {
                dialogFormVisible: false,
                data: {},
                title: `新增`
            },
            compounddrug_search_key: ``,
            buttons: []
        }
    },
    created() {
        this.$store.dispatch(`ADD_SYS_DOCUMENT_LIST`)
    },
    computed: {
        ...mapGetters([`sys_document_list`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `value`,
                isKey: true,
                width: `80`,
                label: `编号`
            }, {
                type: `string`,
                prop: `label`,
                label: `组合名称`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `value`,
                label: `编码`,
                width: `400`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `150`,
                isListable: true,
                fixed: `right`,
                options: (that, { row }) => {
                    return [
                        {
                            class: `is-plain`,
                            label: `编辑`,
                            icon: ``,
                            type: `info`,
                            emit: `editcompounddrug`,
                            permission: `default`
                        },
                        {
                            class: `is-plain`,
                            label: `删除`,
                            icon: ``,
                            type: `danger`,
                            emit: `removeItem`,
                            permission: `default`
                        }

                    ]
                }
            }
            ]
        }
    },
    mounted() {

    },
    methods: {
        ReloadListData() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/CompoundDrug/Search`, { keyword: this.compounddrug_search_key })
                req.then(data => {
                    resolve(data)
                })
            })
        },
        // this.init()
        addcompounddrug() {
            this.saveas.dialogFormVisible = true
            this.saveas.title = `编辑`
            this.saveas.data = {}
            this.saveas.oldcode = null
        },
        editcompounddrug({ row }) {
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/CompoundDrug/GetDrugByGroupCode?groupCode=${row.value}`)
            req.then(drugs => {
                console.log(`GetDrugByGroupCode`)
                console.log(drugs)
                drugs = _.map(drugs, drug => {
                    drug.dic_drug = {
                        label: drug.name,
                        value: drug.id
                    }
                    return drug
                })
                let r = { ...row }
                r.items = drugs
                this.saveas.dialogFormVisible = true
                this.saveas.title = `编辑`
                this.saveas.data = r
                this.saveas.oldcode = row.value
            })
        },
        removeItem({ row }) {
            console.log(row)
            if (row.value) {
                this.$confirm(`是否确定删除?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`
                }).then(() => {
                    let req = this.myaxios.delete(`/api/AcisSystem/CompoundDrug/DeleteByCode?groupCode=${row.value}`)
                    req.then(data => {
                        this.$message.success(`删除成功！`)
                        this.$refs[`drug_list`].ReloadListData()
                        this.ReloadListData()
                    }).catch(e => {
                        console.log(e)
                    })
                })
            }
        },
        saveAsSuccess() {
            this.$refs[`drug_list`].ReloadListData()
            this.ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Drug/CompoundDrug.vue